export const save_alt = (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
    >
        <path
            id="path876"
            d="M0,0V21.373l2.336,2.541L23.98,24V17.967l.006-.527H24V7.053h-.012L23.98,0ZM4.188,2.25H19.568V5.789h.01V9.205H4.188V2.25Zm.52,10.025,12.273.019,2.314,2.41-.031,6.881H4.707Zm1.15,2.879v5.723H9.3V15.154Z"
        />
    </svg>
);
